// Pure display-logic helpers for EditUniverseModal.vue's "Portfolios" and
// "Client Portfolios" tabs.
//
// These were extracted so the rule that matters most -- a search that returns
// nothing must NOT hide the search box (or the user gets stuck unable to edit
// their query) -- is unit-testable without a full Vue component harness.
// See test/unit/load_universe_modal_visibility.js.
//
// Written as CommonJS so it can be `require`d by the node-based unit tests and
// `import`ed by the webpack-built Vue SFC.

function isSearching(searchQuery) {
  return !!(searchQuery && String(searchQuery).trim().length > 0);
}

// Show the search box + results table whenever data is still loading, there are
// results, or a search is active. The "search is active" clause guarantees the
// search input never disappears just because a search matched nothing.
function shouldShowBrowser(loaded, count, searchQuery) {
  return !loaded || count > 0 || isSearching(searchQuery);
}

// "You have no portfolios" empty state -- only when the user genuinely has none
// (loaded, empty, and not merely the result of a search filter).
function shouldShowEmptyMessage(loaded, count, searchQuery) {
  return loaded && count === 0 && !isSearching(searchQuery);
}

// "No portfolios match your search" -- loaded, empty, but a search is active.
function shouldShowNoResultsMessage(loaded, count, searchQuery) {
  return loaded && count === 0 && isSearching(searchQuery);
}

module.exports = {
  isSearching,
  shouldShowBrowser,
  shouldShowEmptyMessage,
  shouldShowNoResultsMessage,
};
